import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

/**
 * UpgradeButton — single "Unlock — RigSentinel Pro" CTA used wherever a
 * premium action was blocked. Renders as a link to /subscription by default.
 * Internal tier names are NEVER displayed.
 */
export default function UpgradeButton({
  label = "Unlock — RigSentinel Pro",
  testid = "upgrade-button",
  size = "md",
  to = "/pricing",
  className = "",
  title,
}) {
  const sizeCls = size === "sm"
    ? "h-8 px-2.5 text-[11px]"
    : size === "lg"
      ? "h-11 px-4 text-sm"
      : "h-9 px-3 text-xs";
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`btn-amber ${sizeCls} rounded-md label-up inline-flex items-center gap-1.5 ${className}`}
      title={title || "Subscribe to RigSentinel Pro to unlock this feature"}
    >
      <Lock className="w-3.5 h-3.5" /> {label}
    </Link>
  );
}
